import { useNavigate } from "react-router-dom";
import { BreadCrumbItemType } from "../../common/types";
import BreadcrumbStyles from "./Breadcrumb.module.scss";

import linkLeftArrowSvg from "../../assets/images/linkArrowLeft.svg";

const Breadcrumb = ({
  list,
  styles = {},
}: {
  list: BreadCrumbItemType[];
  styles?: {};
}) => {
  const navigate = useNavigate();
  const handleClick = (item: BreadCrumbItemType) => {
    const activeItem = list?.[list.length - 1];
    const ifOnlySingleItem = list?.length === 1;
    if (ifOnlySingleItem) {
      navigate(item?.link || "");
    }
    if (item.text === activeItem.text) return;
    if (item?.link) {
      navigate(item?.link);
    }
  };

  return (
    <div className={BreadcrumbStyles.breadcrumb} style={styles}>
      {list?.map((breadcrumb: any, idx: number) => {
        const ifOnlySingleItem = list?.length === 1;
        const isFirstAndLastItem = idx + 1 === list.length;
        const itemClass = ifOnlySingleItem
          ? BreadcrumbStyles.nonCurrentItem
          : isFirstAndLastItem
          ? BreadcrumbStyles.currentItem
          : BreadcrumbStyles.nonCurrentItem;
        return (
          <div
            className={BreadcrumbStyles.breadcrumbItem}
            key={breadcrumb.text + "breadcrumbitem"}
            style={
              ifOnlySingleItem
                ? {
                    gap: "5px",
                  }
                : {}
            }
          >
            {ifOnlySingleItem && <img src={linkLeftArrowSvg} alt="" />}
            {idx > 0 && <p className={BreadcrumbStyles.separator}>/</p>}
            <p className={itemClass} onClick={() => handleClick(breadcrumb)}>
              {breadcrumb?.text}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
